/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ carrier: NonNullable<unknown> }} Carrier_Notices_Default_MessageInputs */

const en_carrier_notices_default_message = /** @type {(inputs: Carrier_Notices_Default_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.carrier} is currently experiencing delays. We suggest using one of our other carriers in the meantime.`)
};

const es_carrier_notices_default_message = /** @type {(inputs: Carrier_Notices_Default_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.carrier} esta experimentando demoras. Recomendamos usar uno de nuestros otros transportistas mientras tanto.`)
};

/**
* | output |
* | --- |
* | "{carrier} is currently experiencing delays. We suggest using one of our other carriers in the meantime." |
*
* @param {Carrier_Notices_Default_MessageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const carrier_notices_default_message = /** @type {((inputs: Carrier_Notices_Default_MessageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Notices_Default_MessageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_carrier_notices_default_message(inputs)
	return es_carrier_notices_default_message(inputs)
});